import { OverlayTrigger, Popover, PopoverBody } from 'react-bootstrap';
import { useState } from 'react';
import { Field } from 'formik';
import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';
import PmsUrlConfig from '../../urlConfig';
import ConfirmPassword from '../ConfirmPassword';
import pmsConstants from '../../pmsConstants';
import { formatPhoneNumber } from '../common';
import Axios from 'axios';

const isPracticeUser = (userType) => {
    return userType === pmsConstants.USER_TYPE_PRACTICE_STRING || userType === pmsConstants.USER_TYPE_PRACTICE;
}

const UserRegistrationComponent = ({ disabled, errors, touched, values, handleChange, prefix, handleBlur, editPage, setFieldValue, dispatch, handleReset, hideActiveSwitch, isSuperUser }) => {
    var activeUser = values.active_user;
    const practiceDetails = useSelector(state => state.practiceDetails);
    if (!practiceDetails || practiceDetails.practice == null)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    const practice = practiceDetails.practice;
    var practiceName = '';
    if (practice)
        practiceName = practice.practice_name;


    const [staffbtnClass, setStaffbtnClass] = useState(() => {
        if (isPracticeUser(values.user_type)) {
            return 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50';
        } else {
            return 'bg-[#0B6D76] border border-[#0B6D76] text-white';
        }
    });
    const [practicebtnClass, setPracticebtnClass] = useState(() => {
        if (isPracticeUser(values.user_type)) {
            return 'bg-[#0B6D76] border border-[#0B6D76] text-white';
        } else {
            return 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50';
        }
    });
    const [isLoading, setIsLoading] = useState(false);

    const generateUsername = async () => {
        if (editPage) {
            return;
        }

        setIsLoading(true);
        var pname = practiceName
        if (!pname || pname === '') {
            pname = values.entityName
        }
        var fName = values.firstname;
        var lName = values.lastname;
        if (fName != null) fName = fName.replace(/\s+/g, '');
        if (lName != null) lName = lName.replace(/\s+/g, '');
        if (pname != null) pname = pname.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '');
        var gen_username = fName + lName + "@" + pname + ".com";
        // values.username = gen_username.toLowerCase();


        var validateUsernameUrl = PmsUrlConfig.BOS_GENERATE_USERNAME + gen_username.toLowerCase()
        // setAuthToken(token);
        Axios.get(validateUsernameUrl)
            .then(response => response.data)
            .then(validUsername => {
                console.log(validUsername)
                values.username = validUsername;
                setIsLoading(false);
            }).catch((error) => {
                console.log("-----------------", error)
                setIsLoading(false);
                if (error.response.data !== null && error.response.data.error_code !== null)
                    dispatch({
                        type: 'practiceUpdateError',
                        payload: error.response.data.error_code.description
                    })
            })

    };

    const handlePhoneNumInput = (e, setFieldValue) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        setFieldValue('phoneNo', formattedPhoneNumber);
    };


    const setButtonActive = (obj_id, setFieldValue) => {
        console.log('Setting button active for:', obj_id);
        if (obj_id === pmsConstants.USER_TYPE_PRACTICE_STRING) {
            setPracticebtnClass('bg-[#0B6D76] border border-[#0B6D76] text-white');
            setStaffbtnClass('bg-white border border-gray-300 text-gray-700 hover:bg-gray-50');
            setFieldValue('user_type', pmsConstants.USER_TYPE_PRACTICE_STRING);
        }
        else {
            setStaffbtnClass('bg-[#0B6D76] border border-[#0B6D76] text-white');
            setPracticebtnClass('bg-white border border-gray-300 text-gray-700 hover:bg-gray-50');
            setFieldValue('user_type', pmsConstants.USER_TYPE_STAFF);
        }
    }
    const setUserIsActive = (isActive, setFieldValue) => {
        activeUser = isActive;
        setFieldValue('active_user', isActive);
    }
    return (
        <div className="w-full space-y-4">
            {/* User Type Tabs */}
            <div className="flex justify-center">
                <div className='inline-flex rounded-lg overflow-hidden shadow-sm border border-gray-300 bg-gray-100'>
                    <OverlayTrigger trigger={["hover", "focus", "click"]} placement='left'
                        overlay={
                            <Popover id='tooltip-practice'>
                                <PopoverBody >
                                    <p>This user will have full privileges to modify all settings including adding users, practice locations.</p>
                                </PopoverBody>
                            </Popover>
                        }>
                        <button 
                            type="button"
                            className={`${practicebtnClass} w-32 px-6 py-2 text-sm font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2 rounded-r-none border-0 ${
                                disabled ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                            value={pmsConstants.USER_TYPE_PRACTICE_STRING}
                            name="user_type" 
                            id={pmsConstants.USER_TYPE_PRACTICE}
                            onClick={() => setButtonActive(pmsConstants.USER_TYPE_PRACTICE_STRING, setFieldValue)}
                            disabled={disabled}>
                            {pmsConstants.USER_TYPE_PRACTICE_STRING}
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger trigger={["hover", "focus", "click"]} placement='right'
                        overlay={
                            <Popover id='tooltip-staff'>
                                <PopoverBody >
                                    <p>This user can view and reply to appointment requests.</p>
                                </PopoverBody>
                            </Popover>
                        }>
                        <button 
                            type="button"
                            className={`${staffbtnClass} w-32 px-6 py-2 text-sm font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2 rounded-l-none border-0 ${
                                disabled ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                            value={pmsConstants.USER_TYPE_STAFF}
                            name="user_type" 
                            id={pmsConstants.USER_TYPE_STAFF}
                            onClick={() => setButtonActive(pmsConstants.USER_TYPE_STAFF, setFieldValue)}
                            disabled={disabled}>
                            {pmsConstants.USER_TYPE_STAFF_STRING}
                        </button>
                    </OverlayTrigger>
                </div>
            </div>

            {/* Hidden Radio Fields */}
            <div className="hidden">
                <Field type="radio" name="user_type" value={pmsConstants.USER_TYPE_PRACTICE_STRING} />
                <Field type="radio" name="user_type" value={pmsConstants.USER_TYPE_STAFF} />
            </div>

            {/* Active Switch (Edit Mode Only) */}
            {editPage && !hideActiveSwitch && (
                <div className="flex justify-center">
                    <label className="flex items-center cursor-pointer">
                        <div className="relative">
                            <input
                                type="checkbox"
                                id="active_user_switch"
                                checked={activeUser}
                                onChange={(e) => setUserIsActive(e.target.checked, setFieldValue)}
                                className="sr-only"
                                disabled={disabled}
                            />
                            <div className={`block w-9 h-5 rounded-full transition-colors duration-200 ${
                                activeUser ? 'bg-[#0B6D76]' : 'bg-gray-300'
                            }`}></div>
                            <div className={`absolute left-0.5 top-0.5 bg-white w-4 h-4 rounded-full transition-transform duration-200 ${
                                activeUser ? 'translate-x-4' : 'translate-x-0'
                            }`}></div>
                        </div>
                        <span className="ml-3 text-sm font-medium text-gray-700">Active</span>
                    </label>
                </div>
            )}

            {/* Form Fields */}
            <div className="space-y-4">
                {/* Name Fields */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor={`${prefix}-input_firstname`} className="block text-sm font-medium text-gray-700 mb-1">
                            First Name <span className="text-red-500">*</span>
                        </label>
                        <Field 
                            type="text" 
                            id={`${prefix}-input_firstname`} 
                            name="firstname" 
                            required
                            onBlur={generateUsername}
                            disabled={disabled}
                            className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${
                                disabled ? 'bg-gray-100 cursor-not-allowed' : ''
                            } ${
                                errors.firstname && touched.firstname 
                                    ? 'border-red-500 bg-red-50' 
                                    : 'border-gray-300'
                            }`} 
                        />
                        {errors.firstname && touched.firstname && (
                            <p className="mt-1 text-sm text-red-600">{errors.firstname}</p>
                        )}
                    </div>
                    <div>
                        <label htmlFor={`${prefix}-input_lastname`} className="block text-sm font-medium text-gray-700 mb-1">
                            Last Name <span className="text-red-500">*</span>
                        </label>
                        <Field 
                            type="text" 
                            id={`${prefix}-input_lastname`} 
                            name="lastname" 
                            required
                            onBlur={generateUsername}
                            disabled={disabled}
                            className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${
                                disabled ? 'bg-gray-100 cursor-not-allowed' : ''
                            } ${
                                errors.lastname && touched.lastname 
                                    ? 'border-red-500 bg-red-50' 
                                    : 'border-gray-300'
                            }`} 
                        />
                        {errors.lastname && touched.lastname && (
                            <p className="mt-1 text-sm text-red-600">{errors.lastname}</p>
                        )}
                    </div>
                </div>

                {/* Username Field */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor={`${prefix}-input_username`} className="block text-sm font-medium text-gray-700 mb-1">
                            Username
                        </label>
                        <div className="flex">
                            <Field
                                type="text"
                                id={`${prefix}-input_username`}
                                name="username"
                                required
                                disabled={disabled || isSuperUser}
                                className={`flex-1 px-3 py-2 border rounded-l-lg focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${
                                    disabled || isSuperUser ? 'bg-gray-100 cursor-not-allowed' : 'bg-gray-50'
                                } ${
                                    errors.username
                                        ? 'border-red-500 bg-red-50'
                                        : 'border-gray-300'
                                }`}
                            />
                            {!editPage && (
                                <button
                                    type="button"
                                    onClick={generateUsername}
                                    className="px-3 py-2 border border-l-0 border-gray-300 rounded-r-lg bg-gray-100 hover:bg-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2"
                                >
                                    <i className="fas fa-sync-alt"></i>
                                </button>
                            )}
                        </div>
                        {errors.username && (
                            <p className="mt-1 text-sm text-red-600">{errors.username}</p>
                        )}
                        {isLoading && (
                            <div className="mt-2 flex items-center text-sm text-gray-500">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#0B6D76] mr-2"></div>
                                Generating username...
                            </div>
                        )}
                        {isSuperUser && (
                            <p className="mt-1 text-sm text-gray-500">Username is set to email address for super user</p>
                        )}
                    </div>
                </div>

                {/* Password Fields */}
                <div>
                    <ConfirmPassword
                        errors={errors}
                        touched={touched}
                        handleBlur={handleBlur}
                        prefix={prefix}
                        disabled={disabled}
                    />
                </div>

                {/* Email and Phone Fields */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor={`${prefix}-input_userEmail`} className="block text-sm font-medium text-gray-700 mb-1">
                            Email
                        </label>
                        <Field 
                            type="email" 
                            id={`${prefix}-input_userEmail`} 
                            name="userEmail"
                            disabled={disabled}
                            className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${
                                disabled ? 'bg-gray-100 cursor-not-allowed' : ''
                            } ${
                                errors.userEmail && touched.userEmail 
                                    ? 'border-red-500 bg-red-50' 
                                    : 'border-gray-300'
                            }`} 
                        />
                        {errors.userEmail && touched.userEmail && (
                            <p className="mt-1 text-sm text-red-600">{errors.userEmail}</p>
                        )}
                    </div>
                    <div>
                        <label htmlFor={`${prefix}-input_userPhoneNo`} className="block text-sm font-medium text-gray-700 mb-1">
                            Phone Number
                        </label>
                        <Field 
                            type="text" 
                            id={`${prefix}-input_userPhoneNo`} 
                            name="phoneNo"
                            onChange={(e) => handlePhoneNumInput(e, setFieldValue)}
                            disabled={disabled}
                            className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${
                                disabled ? 'bg-gray-100 cursor-not-allowed' : ''
                            } ${
                                errors.phoneNo && touched.phoneNo 
                                    ? 'border-red-500 bg-red-50' 
                                    : 'border-gray-300'
                            }`} 
                        />
                        {errors.phoneNo && touched.phoneNo && (
                            <p className="mt-1 text-sm text-red-600">{errors.phoneNo}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

};

export default UserRegistrationComponent;